import http from '../../http'
let del = (data) => {
  return http.post('activityservice/activitysort/delete', data)
}

let list = (data) => {
  return http.post('activityservice/activitysort/list', data)
}

let add = (data) => {
  return http.post('activityservice/activitysort/insert', data)
}

let update = (data) => {
  return http.post('activityservice/activitysort/update', data)
}

export default {
  add,
  update,
  del,
  list
}
